import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, throwError, tap } from 'rxjs';
import { environment } from '../../environments/environmentprod';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isLoggedInSubject = new BehaviorSubject<boolean>(false);
  isLoggedIn$ = this.isLoggedInSubject.asObservable();

  private currentUser: any = null;
  
  constructor(private http: HttpClient,private router:Router) {
    // Initialize from localStorage if user already logged in
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      this.currentUser = JSON.parse(savedUser);
      this.isLoggedInSubject.next(true);
    }
  }

  // Login user
  login(hostUrl: string, credentials: any) {
    return this.http.post(hostUrl + 'auth/login', credentials).pipe(
      tap((user: any) => {
        // Save user data on successful login
        this.currentUser = user;
        this.isLoggedInSubject.next(true);
        localStorage.setItem('user', JSON.stringify(user));
      }),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }
  // google login

  googleLogin(idToken: string) {

  return this.http.post(environment.extApi + 'training/login', {
    token: idToken
  }).pipe(
    tap((user: any) => {

      this.currentUser = user;

      this.isLoggedInSubject.next(true);

      localStorage.setItem('user', JSON.stringify(user));

    }),
    catchError(error => throwError(() => error))
  );

}
  // Signup new user
  signup(hostUrl: string, userData: any) {
    return this.http.post(hostUrl + 'auth/signup', userData).pipe(
      catchError(error => {
        return throwError(() => error);
      })
    );
  }
  
  // registration
   register(registrationData: any) {
    return this.http.post(environment.extApi + '/auth/bootcampRegistration', registrationData)
      .pipe(
        catchError(error => {
          return throwError(() => error);
        })
      );
  }


  // Verify school codes during signup
  verifySchoolCodes(hostUrl: string, schoolData: any) {
    return this.http.post(hostUrl + 'auth/verify-codes', schoolData).pipe(
      catchError(error => {
        return throwError(() => error);
      })
    );
  }

  // Forgot password
  forgotPassword(hostUrl: string, resetData: any) {
    return this.http.post(hostUrl + 'auth/forgot-password', resetData).pipe(
      catchError(error => {
        return throwError(() => error);
      })
    );
  }

  // Logout user
  logout() {
    this.currentUser = null;
    this.isLoggedInSubject.next(false);
    localStorage.removeItem('user');
    this.router.navigate(['/home'])
  }

  // Get current user info
  getUser() {
    return this.currentUser;
  }
}
